<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<template>
  <ElCheckboxGroup
    :value="value || []"
    class="f-c-days"
    :disabled="disabled"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
  >
    <ElCheckboxButton
      :value="1"
      :label="1"
    >Пн
    </ElCheckboxButton>
    <ElCheckboxButton
      :value="2"
      :label="2"
    >Вт
    </ElCheckboxButton>
    <ElCheckboxButton
      :value="3"
      :label="3"
    >Ср
    </ElCheckboxButton>
    <ElCheckboxButton
      :value="4"
      :label="4"
    >Чт
    </ElCheckboxButton>
    <ElCheckboxButton
      :value="5"
      :label="5"
    >Пт
    </ElCheckboxButton>
    <ElCheckboxButton
      :value="6"
      :label="6"
    >Сб
    </ElCheckboxButton>
    <ElCheckboxButton
      :value="7"
      :label="7"
    >Вс
    </ElCheckboxButton>
  </ElCheckboxGroup>
</template>
<style lang="scss">
  .f-c-days {
    line-height: 24px;
    display: flex;
    align-items: center;
    position: relative;

    .el-checkbox-button {
      display: block;
      flex-grow: 1;
      margin: 0;

      .el-checkbox-button__inner {
        height: 24px;
        padding: 0 2px;
        line-height: 24px;
        border: none !important;
        width: 100%;
        background: none;
      }

      &.is-focus {
        background-color: #33415033;
      }

      &.is-checked {
        background-color: #334150;
      }
    }
  }
</style>
